// SEO Configuration for different pages
// IMPORTANT: Ensure each description is unique and 150-160 characters for best SEO.
export const seoConfig = {
  home: {
    title: "EXE - Sri Lanka's Flagship Game Development Competition | LEVELSTAIR",
    description:
      "Join EXE by LEVELSTAIR, Sri Lanka's premier game development competition. Connect with industry professionals, compete for amazing prizes, and showcase your skills.",
    image: "https://exe.levelstair.com/ShareImage.png",
    url: "https://exe.levelstair.com",
    keywords:
      "game development competition Sri Lanka, EXE competition LEVELSTAIR, Unity competition Sri Lanka, Unreal Engine competition Sri Lanka, indie game contest, game jam Sri Lanka, Sri Lankan game developers, game development prizes, industry networking, game programming contest, mobile game development, PC game development, VR game development, game design competition, LEVELSTAIR events",
  },
  exe: {
    title:
      "EXE 2025 - Sri Lanka's Premier Game Development Competition | LEVELSTAIR",
    description:
      "EXE 2025 by LEVELSTAIR: Sri Lanka's flagship game development championship. Compete across multiple categories. Open to all skill levels. Win prizes & mentorship.",
    image: "https://exe.levelstair.com/ExeLogo.png",
    url: "https://exe.levelstair.com",
    keywords:
      "EXE 2025 LEVELSTAIR, game development competition Sri Lanka, Sri Lankan game championship, game dev contest Sri Lanka, Unity competition, Unreal Engine competition, indie game competition, game development prizes, game development event Sri Lanka, Sri Lankan game developers competition, LEVELSTAIR events",
  },
  register: {
    title: "Register for EXE 2025 - Sri Lanka's Premier Game Development Competition | LEVELSTAIR",
    description:
      "Sign up for EXE 2025 by LEVELSTAIR, Sri Lanka's biggest game development competition. Register as individual or team. Connect with developers nationwide.",
    image: "https://exe.levelstair.com/ExeLogo.png",
    url: "https://exe.levelstair.com/register",
    keywords:
      "EXE registration LEVELSTAIR, game development competition registration, register game jam Sri Lanka, Sri Lankan game contest registration, Unity tournament registration, LEVELSTAIR community",
  },
  rules: {
    title: "EXE Competition Rules & Guidelines | EXE 2025 by LEVELSTAIR",
    description:
      "Complete rules and guidelines for EXE 2025 game development competition by LEVELSTAIR. Eligibility criteria, submission requirements, and judging criteria.",
    image: "https://exe.levelstair.com/ExeLogo.png",
    url: "https://exe.levelstair.com/rules",
    keywords:
      "EXE rules LEVELSTAIR, game development competition rules, EXE guidelines, competition eligibility, submission requirements, judging criteria",
  },
  categories: {
    title: "Competition Categories | EXE 2025 Game Development Competition by LEVELSTAIR",
    description:
      "Explore EXE 2025 competition categories by LEVELSTAIR: 2D Games, 3D Games, VR/AR, and Mobile Games. Find the perfect category for your game development skills.",
    image: "https://exe.levelstair.com/ExeLogo.png",
    url: "https://exe.levelstair.com/categories",
    keywords:
      "EXE categories LEVELSTAIR, game development categories, 2D game competition, 3D game competition, VR competition, mobile game competition",
  },
  prizes: {
    title: "Prizes & Rewards | EXE 2025 Game Development Competition by LEVELSTAIR",
    description:
      "Discover amazing prizes at EXE 2025 by LEVELSTAIR: cash rewards, industry mentorship, job opportunities, and recognition. Total prize pool exceeds LKR 500,000.",
    image: "https://exe.levelstair.com/ExeLogo.png",
    url: "https://exe.levelstair.com/prizes",
    keywords:
      "EXE prizes LEVELSTAIR, game development competition prizes, cash rewards, industry mentorship, job opportunities, competition rewards",
  },
  contact: {
    title: "Contact EXE Team | Get Support for Game Development Competition | LEVELSTAIR",
    description:
      "Contact the EXE team at LEVELSTAIR for support, questions, or partnership opportunities. Get help with registration, rules, technical issues, and sponsorships.",
    image: "https://exe.levelstair.com/ExeLogo.png",
    url: "https://exe.levelstair.com/contact",
    keywords:
      "EXE contact LEVELSTAIR, game development competition support, EXE team contact, competition help, sponsorship opportunities",
  },
  exe2025: {
    title: "EXE 2025 - Coming Soon | Sri Lanka's Premier Game Development Competition | LEVELSTAIR",
    description:
      "EXE 2025 by LEVELSTAIR is coming! Sri Lanka's biggest game development competition returns with exciting new features. Stay tuned for registration details.",
    image: "https://exe.levelstair.com/ExeLogo.png",
    url: "https://exe.levelstair.com/exe2025",
    keywords:
      "EXE 2025 LEVELSTAIR, game development competition 2025, Sri Lankan game contest, upcoming game jam, LEVELSTAIR events 2025",
  },
  submissions: {
    title: "Competition Submissions & Winners | EXE Game Development Competition | LEVELSTAIR",
    description:
      "Explore winning games and submissions from EXE competition by LEVELSTAIR. View award-winning games, play submissions, and discover Sri Lankan game dev talent.",
    image: "https://exe.levelstair.com/ExeLogo.png", 
    url: "https://exe.levelstair.com/submissions",
    keywords:
      "EXE submissions LEVELSTAIR, game development winners, Sri Lanka games, competition results, itch.io games, winning games",
  },
};

// Helper function to get SEO data for a page
export const getSEOData = (page) => {
  return seoConfig[page] || seoConfig.home;
};
